import React, { useState } from "react";
import { Activity, ShoppingBag, Star, Users } from "lucide-react";
import EngagementChart from "./EngagementChart";
import CompetitorSearch from "./CompetitorSearch";
import CompetitorTable from "./CompetitorTable";
import StorePreview from "./StorePreview";
import "../Styles/BussinessInsights.css";

const mockData = {
  store: {
    domain: "MYSTORE.COM",
    score: "Home Decor",
    social: {
      instagram: "#",
      facebook: "#",
      twitter: "#",
      youtube: "#",
    },
  },
  metrics: [
    { id: 1, title: "Products", value: 70, icon: ShoppingBag, color: "danger" },
    { id: 2, title: "Satisfaction", value: 59, icon: Star, color: "warning" },
    { id: 3, title: "Sales", value: 65, icon: Activity, color: "success" },
    { id: 4, title: "Users", value: 82, icon: Users, color: "info" },
  ],
  competitors: [
    {
      domain: "amazon.com",
      icon: "/amazon.svg",
      traffic: "2M",
      product: "50M",
      sales: "1B",
    },
    {
      domain: "Flipkart.com",
      icon: "/flipkart.svg",
      traffic: "2M",
      product: "50M",
      sales: "1B",
    },
    {
      domain: "airtel.in",
      icon: "/airtel.svg",
      traffic: "2M",
      product: "50M",
      sales: "1B",
    },
    {
      domain: "bookmyshow.com",
      icon: "/bookmyshow.svg",
      traffic: "2M",
      product: "50M",
      sales: "1B",
    },
  ],
};

const BusinessInsights = () => {
  const [data, setData] = useState(mockData);

  const handleCompetitorSearch = async (query) => {
    console.log("Searching for competitor:", query);
  };

  return (
    <div className="business-insights">
      <div className="container-fluid">
        <div className="row g-4">
          <div className="col-12 col-lg-6">
            <StorePreview store={data.store} />
          </div>

          <div className="col-12 col-lg-6">
            <EngagementChart data={data.engagement} />
          </div>

          <div className="competitors-section row g-4">
            <div className="col-12 col-lg-6">
              <CompetitorSearch onSearch={handleCompetitorSearch} />
            </div>
            <div className="col-12 col-lg-6">
              <CompetitorTable competitors={data.competitors} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessInsights;
